import script from "./EventCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventCard.vue?vue&type=script&lang=ts&setup=true"

import "./EventCard.vue?vue&type=style&index=0&id=65573c31&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65573c31"]])

export default __exports__